import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "../Bits";
import { IMAGES } from "../../lib/images";

const Card = ({ product, index }) => (
  <Reveal delay={index * 0.08}>
    <Link
      to={product.type === "wall" ? "/wall-pads" : `/mats/${product.slug}`}
      data-testid={`category-card-${product.slug}`}
      className="group flex h-full flex-col border border-[#111111]/10 bg-white transition-[border-color] duration-500 hover:border-[#0F4C81]/40"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[#F5F5F2]">
        <img
          src={product.card_image || product.hero_image}
          alt={product.short_name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.05]"
        />
        <span className="mako-label absolute left-0 top-0 bg-white/95 px-4 py-2.5 text-[#0F4C81]">
          {product.label}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-7 lg:p-8">
        <h3 className="font-display text-xl font-bold uppercase tracking-tight text-[#111111]">
          {product.short_name}
        </h3>
        <p className="mt-4 text-sm leading-relaxed text-[#3B3B3B]">{product.card_copy}</p>
        <span className="mako-label mt-8 inline-flex items-center gap-2 self-start text-[#111111] transition-colors duration-300 group-hover:text-[#0F4C81]">
          Explore
          <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </span>
      </div>
    </Link>
  </Reveal>
);

const Categories = ({ products }) => (
  <section
    data-testid="home-categories"
    className="border-t border-[#111111]/10 bg-[#F5F5F2] py-20 lg:py-32"
  >
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <Reveal>
        <SectionHead
          eyebrow="The range"
          title="Choose your surface"
          copy="Every training space is different. Explore professional mat systems designed around your discipline, facility and budget."
        />
      </Reveal>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:mt-20 lg:grid-cols-4">
        {products.map((p, i) => (
          <Card key={p.slug} product={p} index={i} />
        ))}
      </div>

      <Reveal delay={0.1}>
        <Link
          to="/custom-solutions"
          data-testid="category-card-custom"
          className="group mt-6 grid overflow-hidden border border-[#111111]/10 bg-[#111111] lg:grid-cols-12"
        >
          <div className="order-2 p-9 lg:order-1 lg:col-span-7 lg:p-14">
            <span className="mako-label text-[#8AB4DA]">MAKO Custom</span>
            <h3 className="mt-5 font-display text-2xl font-bold uppercase leading-tight tracking-tight text-white sm:text-3xl">
              Custom solutions
            </h3>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-white/70">
              Custom colours, dimensions, branding and complete surface packages for new and
              existing facilities.
            </p>
            <span className="mako-label mt-9 inline-flex items-center gap-2 text-white transition-colors duration-300 group-hover:text-[#8AB4DA]">
              Explore custom
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </span>
          </div>
          <div className="relative order-1 aspect-[16/9] overflow-hidden lg:order-2 lg:col-span-5 lg:aspect-auto">
            <img
              src={IMAGES.custom_logo}
              alt="Combat mat floor with a printed MAKO logo"
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.04]"
            />
          </div>
        </Link>
      </Reveal>
    </div>
  </section>
);

export default Categories;
